/**
 * Created by zzy on 2019/8/5.
 */
import ParkingManagement from './ParkingManagement.vue'
export default ParkingManagement



// WEBPACK FOOTER //
// ./src/views/monitoring/parkingManagement/index.js